import Vue from 'vue'
import {
  Loading
} from 'element-ui';
import utils from './utils'
import store from '../../store'
Vue.use(Loading.directive);

let loading, needLoadingRequestCount = 0
const common = {
  /**
   * @func 加载loading方法
   */
  startLoading() { // 定义loading-start方法
    loading = Loading.service({
      lock: true,
      text: '加载中，请稍后...',
      spinner: 'el-icon-loading',
      background: 'rgba(225, 225, 225, 0.5)'
    });
  },
  /**
   * @func 关闭loading方法
   */
  endLoading() {  // 定义loading-end方法
    loading.close()
  },
  /**
   * @func 请求接口加载loading方法
   */
  showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
      common.startLoading()
    }
    needLoadingRequestCount++
  },
  /**
   * @func 返回响应关闭loading方法
   */
  tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
      common.endLoading()
    }
  },
  /**
   * @func 返回当前跳转url
   * @param URL -需要跳转的地址
   * @param id -跳转需要参数taskId
   */
  getGoUrl(URL, id) {
    let fromCircle = "";
    let runEnv = "";
    if(utils.getUrlParam().fromCircle){
      fromCircle = "&fromCircle="+utils.getUrlParam().fromCircle;
    }
    if(utils.getUrlParam().runEnv){
      runEnv = "&runEnv="+utils.getUrlParam().runEnv;
    }

    return '/#' + URL +
      '?taskId=' + id +
      '&systemId=' + utils.getUrlParam().systemId +
      '&paddingNone=' + (utils.getUrlParam().paddingNone || 0) +
      '&currentActivityId=' + (utils.getUrlParam().currentActivityId || 0) +
      '&render=' + (utils.getUrlParam().render || 0) +
      '&toprocessinfo=' + (utils.getUrlParam().toprocessinfo || 0) +
      '&componentType=' + (utils.getUrlParam().componentType || 0) +
      '&historyGo=' + (utils.getUrlParam().historyGo || 0) +
      '&needBack=' + (utils.getUrlParam().needBack || 0) +
      '&originalTargetUri=' + (utils.getUrlParam().originalTargetUri || 0) +
      fromCircle + runEnv
  },
  getGoUrlInstance(URL, id) {
    let paddingNone
    if (utils.getUrlParam().paddingNone == 1) {
      paddingNone = 1
    } else {
      paddingNone = 0
    }
    return URL + '?instanceId=' + id + '&systemId=' + utils.getUrlParam().systemId + '&paddingNone=' + paddingNone
  },
  changeUrlArg(url, arg, val) {
    if (utils.getUrlParam().currentActivityId != '0' && utils.getUrlParam().currentActivityId) {
      var re = new RegExp('(' + arg + '=)([^&]*)', 'gi');
      var replaceText = arg + '=' + val;
      var nUrl = url.replace(re, replaceText);
      return nUrl
    } else {
      return url
    }
  },
  changeRealUrlArg(url, arg, val) {
    var re = new RegExp('(' + arg + '=)([^&]*)', 'gi');
    var replaceText = arg + '=' + val;
    var nUrl = url.replace(re, replaceText);
    return nUrl
  },
  funcUrlDel(name, instanceId) {
    var loca = window.location;
    var baseUrl = loca.origin + loca.pathname
    var hash = loca.hash.split('?')[0]
    var query = loca.hash.split('?')[1]
    if (query.indexOf(name) > -1) {
      var obj = {}
      var arr = query.split("&");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split("=");
        obj[arr[i][0]] = arr[i][1];
      }
      delete obj[name];
      var url = baseUrl + hash + '?' + `instanceId=${instanceId}&` + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
      return url
    }
  },
  funcUrlDelinstanceId(name, instanceId) {
    var loca = window.location;
    var baseUrl = loca.origin + loca.pathname
    var hash = loca.hash.split('?')[0]
    var query = loca.hash.split('?')[1]
    if (query.indexOf(name) > -1) {
      var obj = {}
      var arr = query.split("&");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split("=");
        obj[arr[i][0]] = arr[i][1];
      }
      delete obj['token'];
      delete obj[name];
      var url = baseUrl + hash + '?' + `instanceId=${instanceId}&` + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
      return url
    }
  },
  funcUrlDelToken() {
    var loca = window.location;
    var baseUrl = loca.origin + loca.pathname
    var hash = loca.hash.split('?')[0]
    var query = loca.hash.split('?')[1]
    // if (query.indexOf(name) > -1) {
      var obj = {}
      var arr = query.split("&");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split("=");
        obj[arr[i][0]] = arr[i][1];
      }
      delete obj['token'];
      var url = baseUrl + hash + '?' + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
      return url
    // }
  },
  /**
   * @func 跳转到指定url,移动端用window.location.replace，pc用window.location.href
   */
  locationType() {
    let isPc = utils.isPC();
    let obj = {
      href: ''
    };
    Object.defineProperty(obj, 'href', {//监听属性变化，跳转url
      set: function (val) {
        if (isPc) {
          window.location.href = val
        } else {
          location.replace(val)
        }
      }
    });
    return obj
  },
  /**
   * @func 控制iframe
   */
  displayIframe() {
    let route = utils.getUrlParam().route,
      iframRoute = [
        "/iframeForm",
        "/hasHandle",
        "/hasHandle/iframeForm",
        "/process",
        "/process/iframeForm",
        "/process/readingLog"
      ],
      routeIframe = iframRoute.indexOf(route) > -1 ? "iframeForm_show" : "iframeForm_hide";
    store.commit('showIframe', routeIframe)
  },
  /**
   * @func 龙信3.0接入
   */
  $toHalfList: function () {
    try {  // 返回列表并刷新
      createIfm('back2history')
    } catch (e) {
    }
  },
  $createIfm: function (type, value, callbackName) {
    try {  // 龙信汇总
      createIfm(type, value, callbackName)
    } catch (e) {
      console.log(e);
    }
  },
  isTipNoClose() {
    if (!vm.$store.state.isShowOptionBox || vm.$store.state.isfirstProcess) {
      window.location.reload()
    } else {
      history.go(-1)
    }
  },
  //关闭页签
  isPRocessorBack: function (vm, action = '') {
    if (vm.$store.state.reloadTabRole == 'true') {
      if (action == 'PROCESS' || action == "SUBMIT") {
        window.location.href = common.changeRealUrlArg(window.location.href, 'originalTargetUri', '0')
        window.location.reload()
        return
      }
    }
    if (vm.$store.state.reloadTab == 'true') {
      if (action == 'PROCESS' || action == "SUBMIT") {
        window.location.href = common.changeRealUrlArg(window.location.href, 'originalTargetUri', '0')
      }
      window.location.reload()
    } else {
      if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
        common.bpmFromEnvDeal(vm,function(){
          window.open(window.location.href, "_self").close();
          open(location, '_self').close();
          if (action == 'PROCESS' || action == "SUBMIT") {
            window.location.href = common.changeRealUrlArg(window.location.href, 'originalTargetUri', '0')
          }
          window.location.reload()
        });

      } else {
        common.bpmFromEnvDeal(vm,function(){
          window.opener = null;
          window.open("", "_self");
          window.close();
        });
      }
    }
  },
  operatorFn: function (Data, vm, other) {
    let index = 0
    if (!other) {
      vm.$store.state.noPersonActivityIdList = []
      vm.$store.state.noPersonActivityNameList = []
    }
    if (!Data) {
      return
    }
    for (let i = 0; i < Data.activitys.length; i++) {
      Data.activitys[i].participantRecords.forEach(item => {
        if (item.participant && item.participant.username && item.participant.realName) {
          item.operator =
            item.participant.realName + "/" +
            item.participant.username;
          if (item.participant.username !== '未找到所属中心') {
            item.name = item.participant.realName + "(" + item.participant.username + ')'
          } else {
            item.name = item.participant.realName
          }
        }
        // participantRecords
        if (item.participant && item.participant.username && item.participant.realName && item.participant.roleName) {
          item.operator = '(' + item.participant.roleName + ')' +
            item.participant.realName + "/" +
            item.participant.username;
          item.role = item.participant.roleName
          if (item.participant.username !== '未找到所属中心') {
            item.name = item.participant.realName + "(" + item.participant.username + ')'
          } else {
            item.name = item.participant.realName
          }
        }
        //判断未找到审批人
        if (item.participant && item.participant.username == '') {
          item.operator =
            '(' + item.participant.roleName + ')' + item.participant.realName
          item.role = item.participant.roleName
          item.name = item.participant.realName;
          if (!other) {
            if (vm.$store.state.participant == vm.$store.state.creator && vm.$store.state.roleNoPersonAdd == 'true' && item.participant.realName == '未找到审批人') {
              Data.activitys[i].roleNoPersonAdd = true
            }
            if (vm.$store.state.submitControl == 2) {
              if (item.participant.realName == '未找到审批人' && index < 1) {
                index++
                vm.$store.state.noPersonActivityIdList.push(Data.activitys[i].activityId)
                vm.$store.state.noPersonActivityNameList.push(Data.activitys[i].activityName)
                vm.$store.state.noPersonActivityIdList = [...new Set(vm.$store.state.noPersonActivityIdList)]
                vm.$store.state.noPersonActivityNameList = [...new Set(vm.$store.state.noPersonActivityNameList)]
              }
            } else {
              // if(vm.$store.state.submitControl==1){
              if (item.participant.realName == '未找到审批人') {
                vm.$store.state.noPersonActivityIdList.push(Data.activitys[i].activityId)
                vm.$store.state.noPersonActivityNameList.push(Data.activitys[i].activityName)
                vm.$store.state.noPersonActivityIdList = [...new Set(vm.$store.state.noPersonActivityIdList)]
                vm.$store.state.noPersonActivityNameList = [...new Set(vm.$store.state.noPersonActivityNameList)]
              }
              // }
            }
          }
        }
        if (item.participant && item.participant.username == '') {
          item.operator =
            '(' + item.participant.roleName + ')' + item.participant.realName
          item.role = item.participant.roleName
          item.name = item.participant.realName;
        }
      });
    }
  },
  submitSelect(vm, action, postData, actionName, isLongfor) {
    let sessionObj
    if (!vm.$store.state.isPc) {
      sessionObj = sessionStorage.getItem('saveObj');
      sessionObj = JSON.parse(sessionObj)
    } else {
      sessionObj = vm.$store.state.saveObj
    }
    let saveObj = {}
    for (const key in sessionObj) {
      const element = sessionObj[key];
      for (const k in element) {
        const value = element[k];
        for (let i = 0; i < value.length; i++) {
          if (!saveObj[key]) {
            saveObj[key] = {}
          }
          if (!saveObj[key][value[i].participant.attributes.roleCode]) {
            saveObj[key][value[i].participant.attributes.roleCode] = []
          }
          if (value[i].bole || value[i].pass) {
            let participant = JSON.parse(JSON.stringify(value[i].participant))
            delete participant.selectBtn
            delete participant.stage
            delete participant.personList
            delete participant.attributes
            //重置选择审批人去除离职的人
            saveObj[key][value[i].participant.attributes.roleCode].push(participant)
          }
        }
      }
    }
    console.log("saveObj~~~~~~~~~~~", saveObj);
    vm.$axios(
      "post",
      `bpm-server/api/runtime/process-instances/${vm.$store.state.processInstID}/actions/appoint-participants?submitControl=${vm.$store.state.submitControl}`,
      saveObj,
      vm
    ).then(res => {
      if (res.data.result == false) {
        return vm.$utils.message(vm, "error", res.data.message);
      }
      if (action == 'SUBMIT') {
        if (vm.$store.state.isAssign) {
          postData.isAssign = vm.$store.state.isAssign
        }
        if (vm.$store.state.nextActivityDefId) {
          postData.nextActivityId = vm.$store.state.nextActivityDefId
        }
        vm.$axios("put", `${vm.api.submit}`, postData, vm).then(res => {
          sessionStorage.removeItem('saveObj');
          try {
            vm.$store.state.isShow = false
            vm.$utils.message(vm, "success", "操作成功");
            clearTimeout(timer)
            if (vm.$store.state.messageSubmitFather) {
              window.parent && window.parent.postMessage(
                {effect: "processSucess"},
                "*"
              ); //成功
            }
            let timer = setTimeout(() => {
              if (!vm.$store.state.isPc) {
                if (vm.$store.state.reloadTabRole == 'true') {
                  common.isTipNoClose()
                  return
                }
                if (!isLongfor) {
                  history.go(-2)
                }
                if (vm.$store.state.render) {
                  createIfm('close', 'refreshList()')
                } else {
                  createIfm('close')
                }
              }
              if (vm.$store.state.isPc) {
                if (vm.$utils.getUrlParam().historyGo && vm.$utils.getUrlParam().historyGo != '0') {
                  window.location.href = decodeURIComponent(vm.$utils.getUrlParam().historyGo)
                } else {
                  common.isPRocessorBack(vm, action)
                }
              }
            }, 2000);
          } catch (e) {
            vm.$utils.message(vm, "error", "失败");
          }
        });
      }
      if (action == 'PROCESS') {
        postData.actionName = actionName
        vm.$axios("put", `/bpm-server/api/runtime/process-instances/${vm.$store.state.processInstID}/actions/start`, postData, vm).then(res => {
          sessionStorage.removeItem('saveObj');
          try {
            if (vm.$store.state.messageSubmitFather) {
              window.parent && window.parent.postMessage(
                {effect: "processSucess"},
                "*"
              ); //成功
            }
            vm.$store.state.isShow = false
            vm.$utils.message(vm, "success", "提交成功");
            clearTimeout(timer)
            let timer = setTimeout(() => {
              if (vm.$store.state.isPc) {
                if (vm.$utils.getUrlParam().historyGo && vm.$utils.getUrlParam().historyGo != '0') {
                  window.location.href = decodeURIComponent(vm.$utils.getUrlParam().historyGo)
                } else {
                  common.isPRocessorBack(vm, action)
                }
              }
              if (!vm.$store.state.isPc) {
                if (vm.$store.state.reloadTabRole == 'true') {
                  common.isTipNoClose()
                  return
                }
                if (!isLongfor) {
                  history.go(-2)
                }
                if (vm.$store.state.render) {
                  createIfm('close', 'refreshList()')
                } else {
                  createIfm('close')
                }
              }
            }, 800);
          } catch (e) {
            vm.$utils.message(vm, "error", "提交失败");
          }
        });
      }
    })
  },
  onSelectBeforeMakeCircle(vm) {
    return new Promise((resolve, reject)=>{
      let sessionObj
      if (!vm.$store.state.isPc) {
        sessionObj = sessionStorage.getItem('saveObj');
        sessionObj = JSON.parse(sessionObj)
      } else {
        sessionObj = vm.$store.state.saveObj;
      }
      let saveObj = {}
      for (const key in sessionObj) {
        const element = sessionObj[key];
        for (const k in element) {
          const value = element[k];
          for (let i = 0; i < value.length; i++) {
            if (!saveObj[key]) {
              saveObj[key] = {}
            }
            if (!saveObj[key][value[i].participant.attributes.roleCode]) {
              saveObj[key][value[i].participant.attributes.roleCode] = []
            }
            if (value[i].bole || value[i].pass) {
              let participant = JSON.parse(JSON.stringify(value[i].participant))
              delete participant.selectBtn
              delete participant.stage
              delete participant.personList
              delete participant.attributes
              //重置选择审批人去除离职的人
              saveObj[key][value[i].participant.attributes.roleCode].push(participant)
            }
          }
        }
      }
      vm.$axios(
        "post",
        `bpm-server/api/runtime/process-instances/${vm.$store.state.processInstID}/actions/appoint-participants?submitControl=${vm.$store.state.submitControl}`,
        saveObj,
        vm
      ).then(res => {
        if (res.data.result == false) {
          reject();
          return vm.$utils.message(vm, "error", res.data.message);
        }
        resolve();
      })
    })
  },
  // 获取云图梭和待办返回链接
  getYtsTodoBackUrl(){
    const getEnv = utils.getEnv();
    let url1 = "",url2 = "";
    switch(getEnv){
      case "prod":
        url1="https://iwork.longfor.com/yts/workbench/";
        url2="https://iwork.longfor.com/yts/aDetails/d6501d27-e1ef-11eb-83e1-00163e1424f5";
        break;
      // DEV not found
      case "pre":
        url1="https://pwb-pre.longfor.com/yts/workbench/";
        url2="https://pwb-pre.longfor.com/yts/aDetails/5de5e27a-d5ac-11eb-a87d-00163e2c9928";
        break;
      case "uat":
        url1="https://iwork-uat.longfor.com/yts/workbench/";
        url2="https://iwork-uat.longfor.com/yts/aDetails/79108890-f436-11eb-a3af-00163e2cf49b";
        break;
      case "sit":
        url1="https://iwork-sit.longfor.com/yts/workbench/";
        url2="https://iwork-sit.longfor.com/yts/aDetails/";
        break;
      default:
        url1="https://iwork.longfor.com/yts/workbench/";
        url2="https://iwork.longfor.com/yts/aDetails/d6501d27-e1ef-11eb-83e1-00163e1424f5";
        break;
    }
    return {url1,url2}
  },
  // 从云图梭和待办中打开的bpm,操作完成后的处理
  bpmFromEnvDeal(vm,callback){
    const {BPM_FROM_ENV,IS_IN_YTS_WEB,IS_IN_YTS_WEB_OUT} = vm.$store.state;
    console.log("关闭页签前来源环境判断",BPM_FROM_ENV,IS_IN_YTS_WEB,IS_IN_YTS_WEB_OUT);
    const {url1,url2} = common.getYtsTodoBackUrl();
    if(BPM_FROM_ENV){
      // 维持原有逻辑
      if(BPM_FROM_ENV==="YTS_WEB" || BPM_FROM_ENV==="TODO_WEB"|| BPM_FROM_ENV==="YTS_DESKTOP_IN" || BPM_FROM_ENV==="TODO_DESKTOP_IN"){
        callback();
      }
      if(BPM_FROM_ENV==="YTS_DESKTOP"){
        callback();
        window.location.href = url1;
      }
      if(BPM_FROM_ENV==="TODO_DESKTOP"){
        callback();
        window.location.href = url2;
      }
      // 关闭云图梭web弹窗
      if(BPM_FROM_ENV==="YTS_WEB_IN"){
        vm.$utils.ytsWebCloseDialog();
      }
      // 关闭待办web弹窗
      if(BPM_FROM_ENV==="TODO_WEB_IN"){
        vm.$utils.todoCloseDialog();
      }
    }else{
      // 云图梭相关代码上完线后--删除
      if(IS_IN_YTS_WEB && !IS_IN_YTS_WEB_OUT){
        vm.$utils.ytsWebCloseDialog();// 关闭云图梭web弹窗
        vm.$utils.todoCloseDialog();// 关闭云图梭web待办弹窗
      }else{
        callback();
      }
    }
  },

  async buttonAxios(vm, type, opinion, file, actionName, activityId, info, checkTurn) {
    opinion = opinion && opinion.replace('<', '&lt;').replace('>', '&gt;')
    //postmessage意见
    if (type == 'SUBMIT' || type == 'PROCESS') {
      opinion = opinion + vm.$store.state.meassageOpinion
    }
    vm.$store.state.buttonArgument = {
      vm: vm,
      type: type,
      opinion: opinion,
      file: file,
      actionName: actionName,
      activityId: activityId,
      info: info,
      checkTurn: checkTurn
    }
    if (!vm.$store.state.buttonTrue) {
      for (const key in vm.$store.state.MessageSecondObj) {
        const element = vm.$store.state.MessageSecondObj[key];
        if (element == 'true') {
          if ((type == 'SUBMIT' || type == 'PROCESS') && key == 'SUBMIT') {
            vm.$store.state.iframeWin.contentWindow.postMessage({secondClick: key}, "*");
            console.log('bpm发送消息交互，请回传消息', {secondClick: key});
            common.showFullScreenLoading()
            return
          }
          if (key == type) {
            vm.$store.state.iframeWin.contentWindow.postMessage({secondClick: key}, "*");
            console.log('bpm发送消息交互，请回传消息', {secondClick: key});
            common.showFullScreenLoading()
            return
          }
        }
      }
    }
    vm.$store.state.buttonTrue = false
    // 催办
    let URGENT = `/bpm-server/api/runtime/process-instances/${vm.$store.state.processInstID}/actions/press`
    // 终止
    let terminate = `/bpm-server/api/runtime/process-instances/${vm.$store.state.processInstID}/actions/terminate`
    let postData = {}
    postData.attachmentRelation = file || []
    postData.opinion = opinion || ''
    //ly传字段 submit
    postData.actionName = actionName || '通过'
    if (vm.$store.state.orgPersonUserId) {
      postData.attributes = {
        orgPersonUserId: vm.$store.state.orgPersonUserId,
        orgPersonUserName: vm.$store.state.orgPersonUserName
      }
    } else {
      postData.attributes = {}
    }
    let userAgent = navigator.userAgent;//获取UA信息
    let isLongfor = userAgent.indexOf('com.longfor') > -1 || userAgent.indexOf('kuaiyixing.CheYiXing') > -1
    switch (type) {
      case 'SUBMIT':
        postData.variables = {key: vm.$store.state.currentParticipant}
        if (vm.$store.state.isSupplyRole) {
          postData.isSupplyRole = 'true'
        }
        console.log("二次确认通过按钮");
        if (info) {
          postData.attributes.infoMap = info
        }
        if (vm.$store.state.nextActivityDefId) {
          postData.nextActivityId = vm.$store.state.nextActivityDefId
        }
        if (JSON.stringify(vm.$store.state.appointObj) == "{}") {
          if (vm.$store.state.isAssign) {
            postData.isAssign = vm.$store.state.isAssign
          }
          vm.$axios("put", `${vm.api.submit}`, postData, vm).then(res => {
            try {
              vm.$store.state.isShow = false
              vm.$utils.message(vm, "success", "操作成功");
              clearTimeout(timer)
              if (vm.$store.state.messageSubmitFather) {
                window.parent && window.parent.postMessage(
                  {effect: "processSucess"},
                  "*"
                ); //成功
              }
              let timer = setTimeout(() => {
                if (!vm.$store.state.isPc) {
                  if (vm.$store.state.reloadTabRole == 'true') {
                    common.isTipNoClose()
                    return
                  }
                  if (!isLongfor) {
                    history.go(-2)
                  }
                  if (vm.$store.state.render) {
                    createIfm('close', 'refreshList()')
                  } else {
                    createIfm('close')
                  }
                }
                if (vm.$store.state.isPc) {
                  if (vm.$utils.getUrlParam().historyGo && vm.$utils.getUrlParam().historyGo != '0') {
                    window.location.href = decodeURIComponent(vm.$utils.getUrlParam().historyGo)
                  } else {
                    common.isPRocessorBack(vm, 'SUBMIT')
                  }
                }
              }, 2000);
            } catch (e) {
              vm.$utils.message(vm, "error", "失败");
            }
          });
        } else {
          common.submitSelect(vm, 'SUBMIT', postData, actionName, isLongfor)
        }
        break;
      case 'NEGOTIATEREPLY':
        if (vm.$store.state.isAssign) {
          postData.isAssign = vm.$store.state.isAssign
        }
        vm.$axios("put", `${vm.api.submit}`, postData, vm).then(res => {
          try {
            vm.$store.state.isShow = false
            vm.$utils.message(vm, "success", "操作成功");
            clearTimeout(timer)
            let timer = setTimeout(() => {
              if (!vm.$store.state.isPc) {
                // lxbridge.callHandler("back2history", 1, function (response) { })
                if (!isLongfor) {
                  history.go(-2)
                }
                if (vm.$store.state.render) {
                  createIfm('close', 'refreshList()')
                } else {
                  createIfm('close')
                }
              }
              if (vm.$store.state.isPc) {
                if (vm.$utils.getUrlParam().historyGo && vm.$utils.getUrlParam().historyGo != '0') {
                  window.location.href = decodeURIComponent(vm.$utils.getUrlParam().historyGo)
                } else {
                  common.isPRocessorBack(vm)
                }
              }
            }, 2000);
          } catch (e) {
            vm.$utils.message(vm, "error", "失败");
          }
        });
        break;
      case 'NEGOTIATEREPLYTASKID':
        if (vm.$store.state.isAssign) {
          postData.isAssign = vm.$store.state.isAssign
        }
        vm.$axios("put", `/bpm-server/api/runtime/tasks/${vm.$store.state.negotiaTaskId}/actions/submit`, postData, vm).then(res => {
          try {
            vm.$store.state.isShow = false
            vm.$utils.message(vm, "success", "操作成功");
            clearTimeout(timer)
            let timer = setTimeout(() => {
              if (!vm.$store.state.isPc) {
                // lxbridge.callHandler("back2history", 1, function (response) { })
                if (!isLongfor) {
                  history.go(-2)
                }
                if (vm.$store.state.render) {
                  createIfm('close', 'refreshList()')
                } else {
                  createIfm('close')
                }
              }
              if (vm.$store.state.isPc) {
                if (vm.$utils.getUrlParam().historyGo && vm.$utils.getUrlParam().historyGo != '0') {
                  window.location.href = decodeURIComponent(vm.$utils.getUrlParam().historyGo)
                } else {
                  common.isPRocessorBack(vm)
                }
              }
            }, 2000);
          } catch (e) {
            vm.$utils.message(vm, "error", "失败");
          }
        });
        break;
      //撤回
      case 'CANCEL':
        if (vm.$store.state.isAssign) {
          postData.isAssign = vm.$store.state.isAssign
        }
        vm.$axios("put", `${vm.api.cancel}`, {actionName: actionName}, vm).then(res => {
          try {
            vm.$utils.message(vm, "success", "撤回成功");
            clearTimeout(timer);
            let timer = setTimeout(() => {
              if (vm.$store.state.systemNo == 'RISK') {
                if (vm.$store.state.isPc) {

                    // 旧的业务
                  if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
                    common.bpmFromEnvDeal(vm,function(){
                      window.open('', '_self', '');
                      window.close();
                    })
                    window.location.reload();
                  } else {
                    window.opener = null;
                    common.bpmFromEnvDeal(vm,function(){
                      window.open("", "_self");
                      window.close();
                    })
                  }
                } else {
                  createIfm('close', 'refreshList()')
                }
              } else {
                if (vm.$store.state.isPc) {
                  let arrUrl = window.location.href.split('?')
                  let para = arrUrl[0]
                  let goUrl = common.getGoUrlInstance(para, vm.$store.state.processInstID);
                  if (vm.$utils.getUrlParam().historyGo && vm.$utils.getUrlParam().historyGo != '0') {
                    window.location.href = decodeURIComponent(vm.$utils.getUrlParam().historyGo)
                  } else {
                    //撤回更换url
                    window.location.href = goUrl
                    window.location.reload()
                  }
                }
                if (!vm.$store.state.isPc) {
                  if (!isLongfor) {
                    history.go(-1)
                  }
                  if (vm.$store.state.render) {
                    createIfm('close', 'refreshList()')
                  } else {
                    createIfm('close')
                  }
                }
              }
            }, 2000);
          } catch (e) {
            vm.$utils.message(vm, "error", "撤回失败");
          }
        });
        break;
      //驳回
      case 'BACK':
        postData.variables = {key: vm.$store.state.currentParticipant}
        if (vm.$store.state.isSupplyRole) {
          postData.isSupplyRole = 'true'
        }
        postData.actionName = actionName
        if (vm.$store.state.isAssign) {
          postData.isAssign = vm.$store.state.isAssign
        }
        postData.activityId = activityId //activityId;
        postData.backsegment = vm.$store.state.backsegment ? vm.$store.state.backsegment : null
        postData.refluxStrategy = vm.$store.state.refluxStrategy ? vm.$store.state.refluxStrategy : null
        if (vm.$store.state.appoint) {
          if (vm.$store.state.refluxStrategy == 'null') {
            vm.$utils.message(vm, "error", "请选择回流方式");
            return
          }
        }
        vm.$axios("put", `${vm.api.back}`, postData, vm).then(res => {
          try {
            vm.$store.state.isShow = false
            vm.$utils.message(vm, "success", "驳回成功");
            if (vm.$store.state.messageSubmitFather) {
              window.parent && window.parent.postMessage(
                {effect: "BACK"},
                "*"
              ); //成功
            }
            clearTimeout(timer)
            let timer = setTimeout(() => {
              if (vm.$store.state.isPc) {
                if (vm.$utils.getUrlParam().historyGo && vm.$utils.getUrlParam().historyGo != '0') {
                  window.location.href = decodeURIComponent(vm.$utils.getUrlParam().historyGo)
                } else {
                  common.isPRocessorBack(vm)
                }
              }
              if (!vm.$store.state.isPc) {
                if (!isLongfor) {
                  history.go(-2)
                }
                if (vm.$store.state.render) {
                  createIfm('close', 'refreshList()')
                } else {
                  createIfm('close')
                }
              }
            }, 2000);
          } catch (e) {
            vm.$utils.message(vm, "error", "驳回失败");
          }
        });
        break;
      //终止
      case 'TERMINATION':
        postData.actionName = actionName
        if (vm.$store.state.isAssign) {
          postData.isAssign = vm.$store.state.isAssign
        }
        if (vm.$store.state.BRZZ) {
          vm.$axios("get", `/bpm-server/api/runtime/process-role-supply/deleteRoleSupplyProcess/${vm.$store.state.instanceId}`, postData, vm).then(res => {
            if (vm.$store.state.messageSubmitFather) {
              window.parent && window.parent.postMessage(
                {effect: "TERMINATION"},
                "*"
              ); //成功
            }
            sessionStorage.removeItem('saveObj');
            clearTimeout(timer)
            let timer = setTimeout(() => {
              if (vm.$store.state.isPc) {
                if (vm.$utils.getUrlParam().historyGo && vm.$utils.getUrlParam().historyGo != '0') {
                  window.location.href = decodeURIComponent(vm.$utils.getUrlParam().historyGo)
                } else {
                  common.isPRocessorBack(vm)
                }
              }
              if (!vm.$store.state.isPc) {
                if (!isLongfor) {
                  history.go(-2)
                }
                if (vm.$store.state.render) {
                  createIfm('close', 'refreshList()')
                } else {
                  createIfm('close')
                }
              }
            }, 2000);
          })
        } else {
          vm.$axios("put", `${terminate}`, postData, vm).then(res => {
            try {
              if (vm.$store.state.messageSubmitFather) {
                window.parent && window.parent.postMessage(
                  {effect: "TERMINATION"},
                  "*"
                ); //成功
              }
              vm.$store.state.isShow = false
              vm.$utils.message(vm, "success", "操作成功");
              sessionStorage.removeItem('saveObj');
              clearTimeout(timer)
              let timer = setTimeout(() => {
                if (vm.$store.state.isPc) {
                  if (vm.$utils.getUrlParam().historyGo && vm.$utils.getUrlParam().historyGo != '0') {
                    window.location.href = decodeURIComponent(vm.$utils.getUrlParam().historyGo)
                  } else {
                    common.isPRocessorBack(vm)
                  }
                }
                if (!vm.$store.state.isPc) {
                  if (!isLongfor) {
                    history.go(-2)
                  }
                  if (vm.$store.state.render) {
                    createIfm('close', 'refreshList()')
                  } else {
                    createIfm('close')
                  }
                }
              }, 2000);
            } catch (e) {
              vm.$utils.message(vm, "error", "操作失败");
            }
          });
        }
        break;
      //催办
      case 'URGENT':
        vm.$axios("put", `${URGENT}`, {}, vm).then(res => {
          try {
            vm.$utils.message(vm, "success", "催办成功");
          } catch (e) {
            vm.$utils.message(vm, "error", "催办失败");
          }
        });
        break;
      //暂存
      case 'TEMPORARYSAVE':
        let postTaskId = vm.$store.state.taskId;
        if (vm.$utils.getUrlParam().instanceId != 'undefined' && vm.$utils.getUrlParam().instanceId) {
          vm.$axios("put", `/bpm-server/api/runtime/process-instances/${vm.$store.state.processInstID}/actions/save`, postData, vm).then(res => {
            try {
              vm.$utils.message(vm, "success", "暂存成功", 2000);
            } catch (e) {
              vm.$utils.message(vm, "error", "暂存失败", 2000);
            }
          });
        } else {
          vm.$axios("put", `/bpm-server/api/runtime/process-instances/${vm.$store.state.processInstID}/actions/save?taskId=${postTaskId}`, postData, vm).then(res => {
            try {
              vm.$utils.message(vm, "success", "暂存成功", 2000);
            } catch (e) {
              vm.$utils.message(vm, "error", "暂存失败", 2000);
            }
          });
        }
        break;
      case 'PROCESS':
        postData.variables = {key: vm.$store.state.currentParticipant}
        if (info) {
          postData.attributes.infoMap = info
        }
        if (JSON.stringify(vm.$store.state.appointObj) == "{}") {
          postData.actionName = actionName
          vm.$axios("put", `/bpm-server/api/runtime/process-instances/${vm.$store.state.processInstID}/actions/start`, postData, vm).then(res => {
            try {
              if (vm.$store.state.messageSubmitFather) {
                window.parent && window.parent.postMessage(
                  {effect: "processSucess"},
                  "*"
                ); //成功
              }
              vm.$store.state.isShow = false
              vm.$utils.message(vm, "success", "提交成功");
              clearTimeout(timer)
              let timer = setTimeout(() => {
                if (vm.$store.state.isPc) {
                  if (vm.$utils.getUrlParam().historyGo && vm.$utils.getUrlParam().historyGo != '0') {
                    window.location.href = decodeURIComponent(vm.$utils.getUrlParam().historyGo)
                  } else {
                    common.isPRocessorBack(vm, 'PROCESS')
                  }
                }
                if (!vm.$store.state.isPc) {
                  if (vm.$store.state.reloadTabRole == 'true') {
                    common.isTipNoClose()
                    return
                  }
                  if (!isLongfor) {
                    history.go(-2)
                  }
                  if (vm.$store.state.render) {
                    createIfm('close', 'refreshList()')
                  } else {
                    createIfm('close')
                  }
                }
              }, 800);
            } catch (e) {
              vm.$utils.message(vm, "error", "提交失败");
            }
          });
        } else {
          common.submitSelect(vm, 'PROCESS', postData, actionName, isLongfor)
        }
        break;
      //查看暂存 现在没用
      case 'VIEWINFORMATION':
        if (vm.$utils.getUrlParam().instanceId != 'undefined' && vm.$utils.getUrlParam().instanceId) {
          vm.$axios('get', `bpm-server/api/runtime/process-instances/${vm.$store.state.processInstID}/temporary-info`, {}, vm).then(res => {
            try {
              vm.$store.state.isShow = false
              vm.$store.state.approvalOpinion = res.data.opinion;
              if (!res.data.opinion) {
                //按钮默认意见
                vm.$store.state.btnParams.forEach(item => {
                  if (item.paramKey == 'appointViews') {
                    if (item.paramValue) {
                      vm.$store.state.approvalOpinion = item.paramValue
                    } else {
                      vm.$store.state.btnParams.forEach(jtem => {
                        if (jtem.defaultViews) {
                          vm.$store.state.approvalOpinion = jtem.paramValue
                        }
                      })
                    }
                  }
                })
              }
            } catch (e) {
              vm.$tiptoast('失败', false);
            }
          })
        } else {
          let postId = {taskId: vm.$store.state.taskId};
          vm.$axios('get', `bpm-server/api/runtime/process-instances/${vm.$store.state.processInstID}/temporary-info`, postId, vm).then(res => {
            try {
              vm.$store.state.isShow = false
              vm.$store.state.approvalOpinion = res.data.opinion;
              if (checkTurn == "SUBMIT" && !res.data.opinion) {
                vm.$store.state.approvalOpinion = '同意'
              }
              if (!res.data.opinion) {
                vm.$store.state.btnParams.forEach(item => {
                  if (item.paramKey == 'appointViews') {
                    if (item.paramValue) {
                      vm.$store.state.approvalOpinion = item.paramValue
                    } else {
                      vm.$store.state.btnParams.forEach(jtem => {
                        if (jtem.defaultViews) {
                          vm.$store.state.approvalOpinion = jtem.paramValue
                        }
                      })
                    }
                  }
                })
              }
            } catch (e) {
              vm.$tiptoast('失败', false);
            }
          })
        }
        break;
      //驳回选择审批环节
      case "EXAMINEAPPROVE":
        let taskId = vm.$store.state.workItemId;
        if (taskId) {
          await vm.$axios('get', `/bpm-server/api/runtime/tasks/${taskId}/activities`, vm.$store.state.btnParams, vm).then(res => {
            // sessionStorage.removeItem('saveObj');
            try {
              vm.$store.state.examineList = res.data.activityList;
            } catch (e) {
              vm.$tiptoast('失败', false);
            }
          })
        }
        break;
      default:
        break;
    }
  }
}

export default common



// WEBPACK FOOTER //
// ./src/assets/js/common.js